module.exports = __webpack_public_path__ + "images/emoji/clap.87c032789dd5ff20b7e9.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/clap.png
// module id = pNrf
// module chunks = 24